<template>
  <div class="promo-modal">
    <div class="modal-background" @click.self="$emit('close')">
      <div class="modal-wrapper" :class="$mq">
        <div class="modal" :class="{ TA: isTestAchat }">
          <h1>
            {{ title }}
            <span class="close" @click="$emit('close')"></span>
          </h1>
          <!-- html comes from renderPromoText(): escaped, only bold and line breaks are tags -->
          <div class="promo-modal__text" v-html="html"></div>
        </div>
        <button class="button main" @click="$emit('close')">{{ $t('back') }}</button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

// ER-3062: "Infos et conditions" window of a cashback, rendered by the carousel (like the details window)
// because the product cards are semi-transparent.
export default {
  name: "PromoModal",
  props: {
    title: {
      type: String,
      required: true
    },
    html: {
      type: String,
      required: true
    }
  },
  computed: {
    ...mapGetters("common", ["isTestAchat"])
  }
};
</script>

<style lang="scss" scoped>
.promo-modal__text {
  padding: 15px;
  background: $white;
  font-size: 0.85rem;
  line-height: 1.4;
  text-align: left;
}

h1 {
  justify-content: center;
  align-items: center;
  background: $yellow;
  text-align: center !important;
  font-size: 1.2rem !important;
  display: block;
  padding: 10px 30px;
}

.modal.TA h1 {
  background: $orange !important;
}
</style>



// WEBPACK FOOTER //
// src/views/simulation/PromoModal.vue